export function sailTypeCoefficient (sail_type) {
  const coefficients = {
    1: 18.05,
    2: 27.77
  }

  return coefficients[sail_type] ?? 0
}
